<template>
  <div class="ratios-pane-fill-indicator" aria-hidden="true">
    <div class="ratios-pane-fill-indicator__fill" :style="{ height: `${fillHeightPx}px` }" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  heightPx: number
  fillFraction: number
}>()

const fillHeightPx = computed(() => {
  const clampedFraction = Math.min(1, Math.max(0, props.fillFraction))
  if (clampedFraction <= 0) return 0

  const raw = props.heightPx * clampedFraction
  return Math.min(props.heightPx, Math.max(1, Math.round(raw)))
})
</script>

<style lang="postcss" scoped>
.ratios-pane-fill-indicator {
  @apply absolute bottom-px right-px top-px;
  width: 6px;
  background: #ffffff;
  border-left: 1px solid rgba(209, 213, 219, 1);
}

.ratios-pane-fill-indicator__fill {
  @apply absolute left-0 right-0 top-0;
  background: rgba(209, 213, 219, 1);
}
</style>
